import SurveyResponsesMonthlyTableCell from './SurveyResponsesMonthlyTableCell';

export default SurveyResponsesMonthlyTableCell;
